<template>
<div class="lineLoader"
  ref="lineLoader"
  >
  <svg
    class="svg"
    v-show="paused === false"
    width="100%"
    :height="`${height}px`"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="7.70848743%" y1="0%" x2="95.8025148%" y2="100%" id="linearGradient-1">
        <stop stop-color="#E6F8F3" offset="0%"></stop>
        <stop stop-color="#52C0A5" offset="33.7853675%"></stop>
        <stop stop-color="#B8E5DA" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <rect
        id="Rectangle"
        fill="url(#linearGradient-1)"
        :x="x"
        :y="y"
        :width="width"
        :height="height"
        rx="2">
      </rect>
    </g>
  </svg>
</div>
</template>
<script>
export default {
  data () {
    return {
      x: 0,
      y: 0,
      height: 5,
      width: 200,
      totalWidth: 1000,
      smoothDelay: 10,
      roughDelay: 40,
      isRunning: false,
      forwardDirection: true,
      paused: false
    }
  },
  mounted () {
    let container = this.$refs.lineLoader
    this.totalWidth = container.getBoundingClientRect().width

    this.animateStep()
  },
  methods: {
    animateStep () {
      if (this.isRunning) return

      this.isRunning = true

      let percentage = this.x / this.totalWidth
      let stepSize = 5 + 10 * percentage * percentage

      this.x = this.forwardDirection === true ? this.x + stepSize : this.x - stepSize

      if (this.x > this.totalWidth) {
        this.forwardDirection = false
      } else if (this.x < -this.width) {
        this.forwardDirection = true
      }

      if (this.paused === false) {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(() => {
            setTimeout(() => {
              this.isRunning = false
              this.animateStep()
            }, this.smoothDelay)
          })
        } else {
          setTimeout(() => {
            this.isRunning = false
            this.animateStep()
          }, this.roughDelay)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .lineLoader {
    left: 0px;
    right: 0px;
    height: 5px;
    width: 100%;
    position: relative;
  }

  .svg {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }
</style>
